import React, { useState } from "react";
import { FreeSwitchDevelopersFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Replace Physical Presence",
    content:
      "We all lose potential clients when we can't reach the meeting location or primarily when we can't have a physical meeting. Audio-video conferencing solutions act as an escape in such a scenario where you can conduct meetings from any geographic location and be as effective as in person. This means the sky is the limit, and you can quickly grab lucrative opportunities in different locations.",
  },
  {
    title: "Efficient Communication",
    content:
      "With conferencing solutions, communication becomes much more efficient. It allows you to connect with your team or clients at any time without the need to be physically present.",
  },
  {
    title: "Ensure Participants Presence",
    content:
      "Conferencing solutions help ensure that all participants are present and engaged during the meeting by providing tools like attendance tracking, screen sharing, and real-time interaction.",
  },
  {
    title: "Consolidated Communication",
    content:
      "The use of conferencing solutions consolidates all forms of communication, allowing for seamless meetings without worrying about connectivity or location.",
  },
];

const WebRTc = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Build seamless real-time communication apps with our expert WebRTC Development Services. Enhance video, voice & chat experiences with Ayanshtech Solutions."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="WebRTC Development Services | Real-Time Communication Apps | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta property="og:url" content="https://ayanshtechnology.com/webrtc" />
        <meta
          property="og:description"
          content="Build seamless real-time communication apps with our expert WebRTC Development Services. Enhance video, voice & chat experiences with Ayanshtech Solutions."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="WebRTC Development Services | Real-Time Communication Apps | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Build seamless real-time communication apps with our expert WebRTC Development Services. Enhance video, voice & chat experiences with Ayanshtech Solutions."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/webrtc" />
        <title>
          WebRTC Development Services | Real-Time Communication Apps |
          Ayanshtech Solutions
        </title>
      </Helmet>
      <div className="min-h-screen flex flex-col items-center justify-center p-6">
        <div className=" w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16  mt-10">
            <div className="lg:w-3/4  lg:text-left p-4 ">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                WebRTC Development Services for Real-Time Communication Apps
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Enhance your business communication with our custom WebRTC
                development services designed for real-time communication apps.
                We build secure, scalable, and high-performance solutions that
                enable seamless video, voice, and data sharing across all
                platforms.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Our expert developers ensure low-latency, high-quality
                interactions that deliver an exceptional user experience—even
                under heavy network loads. Whether you’re building a video
                conferencing app, live streaming platform, or customer support
                system, our WebRTC solutions ensure crystal-clear communication
                and smooth collaboration.
              </p>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                From concept to deployment, we provide end-to-end WebRTC
                development services tailored to your business goals. Our team
                works closely with you to design, develop, and integrate
                solutions that align perfectly with your existing
                infrastructure, ensuring reliability, performance, and
                scalability.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500
 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center  mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\headerSection\webrtc1.webp"
                alt="WebRTC Development Services"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Features of Our WebRTC Solutions Development
          </h2>
        </div>

        <div className=" p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Real-time video and audio streaming</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Secure peer-to-peer communication</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Cross-platform compatibility</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Low latency and high scalability</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our WebRTC Solutions Development Services
          </h2>
        </div>

        <div className=" p-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="/assets/images/headerSection/webrtc2.webp"
                alt="WebRTC Communication"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon5.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Build high-quality, low-latency video and audio
                    communication
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon6.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Real-time data sharing and collaboration integration
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon7.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Secure peer-to-peer communications with end-to-end
                    encryption
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon8.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Optimized for cross-platform communication across browsers
                    and devices
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon9.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable WebRTC infrastructure tailored for your business
                    needs
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon10.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Seamless integration with existing web and mobile
                    applications
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              WebRTC Solutions We Develop
            </h2>
          </div>

          <div className=" p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Real-Time Video Communication
                </h3>
                <p className="text-lg">
                  Develop high-quality video communication apps for personal and
                  business use, providing low-latency interactions.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Audio Conferencing</h3>
                <p className="text-lg">
                  Build secure and scalable audio conferencing solutions for
                  teams, with support for multiple participants in real-time.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">
                  Data Sharing and Collaboration
                </h3>
                <p className="text-lg">
                  Create seamless peer-to-peer data sharing and collaboration
                  tools for enhanced team productivity and communication.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">WebRTC to SIP Gateway</h3>
                <p className="text-lg">
                  Integrate WebRTC with SIP infrastructure to bridge
                  communication between browsers and traditional VoIP systems.
                </p>
              </div>

              {/* Item 5 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Screen Sharing</h3>
                <p className="text-lg">
                  Provide high-quality screen sharing functionality for online
                  meetings, support sessions, and collaborative work.
                </p>
              </div>

              {/* Item 6 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Cross-Platform Support</h3>
                <p className="text-lg">
                  Ensure seamless communication across all devices, including
                  desktops, smartphones, and tablets, using WebRTC technology.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-green-50 p-6 sm:p-8 mb-12 sm:mb-16 rounded-3xl">
          {/* Title Section */}
          <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-6">
            Pain Points & Solutions
          </h2>

          {/* Navigation Bar */}
          <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
            {pointsData.map((point, index) => (
              <button
                key={index}
                className={`text-base sm:text-lg font-medium ${
                  activeIndex === index
                    ? "text-blue-600 underline"
                    : "text-gray-900"
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {point.title}
              </button>
            ))}
          </div>

          {/* Content Section */}
          <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
              {pointsData[activeIndex].content}
            </p>
          </div>
        </div>

        <div className="  w-full rounded-3xl p-6">
          <div className="text-center mb-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              WebRTC Solutions Development and Support Services
            </h2>
          </div>

          <div className="mb-8 text-left">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech provides WebRTC solutions development and support
              services to help businesses build scalable and reliable real-time
              communication applications. Whether you are looking to implement
              video conferencing, live streaming, or peer-to-peer communication,
              our team of experts can assist you at every step. Here are some of
              the consulting and development services offered by Ayanshtech:
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Some of the key services include:
            </p>
            <ul className="list-disc pl-8  sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>WebRTC application development and deployment</li>
              <li>Real-time video and audio communication solutions</li>
              <li>Customizable video conferencing platforms</li>
              <li>Integration of WebRTC with existing VoIP and SIP systems</li>
              <li>Scalable WebRTC infrastructure design</li>
              <li>Performance optimization and monitoring</li>
              <li>Security and compliance for WebRTC applications</li>
              <li>Training and knowledge transfer</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              By leveraging Ayanshtech’s WebRTC solutions development services,
              businesses can build robust communication platforms that meet the
              needs of today’s dynamic digital environment, while ensuring
              optimal performance, security, and user experience.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:border-blue-600 text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {FreeSwitchDevelopersFaqs.map((faq, index) => (
            <div key={index} className="border-b ">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default WebRTc;
